import { dtTokenScope, dtFocusRing } from './css-recipes';

/**
 * InspectorCard CSS — shipped as an injected style string (the platform build
 * has no css-loader, so an SFC `<style>` block cannot be parsed).
 *
 * Design contract lives in `css-recipes.ts`: this file consumes `var(--dt-*)`
 * exclusively. The card declares its own token scope because it can mount
 * outside the panel (dev-shell embeds cards directly).
 *
 * `scoped` is gone, so every selector is namespaced under `.abax-inspector-card`
 * (the card root) to prevent leakage.
 */
export const INSPECTOR_CARD_CSS = /* css */ `
${dtTokenScope('.abax-inspector-card')}

.abax-inspector-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--dt-border);
  border-radius: var(--dt-radius);
  background: var(--dt-bg);
  overflow: hidden;
}

.abax-inspector-card .inspector-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--dt-fg);
  font-family: inherit;
  font-size: var(--dt-text-base);
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background var(--dt-dur-fast) var(--dt-ease);
}

.abax-inspector-card .inspector-card__header:hover {
  background: color-mix(in srgb, var(--dt-fg) 4%, transparent);
}

${dtFocusRing('.abax-inspector-card .inspector-card__header', '-2px')}

.abax-inspector-card .inspector-card__chevron {
  display: inline-flex;
  color: var(--dt-muted-fg);
  flex-shrink: 0;
  font-size: 1rem;
  line-height: 1;
  transition: transform var(--dt-dur-fast) var(--dt-ease);
}

.abax-inspector-card.inspector-card--open .inspector-card__chevron {
  transform: rotate(90deg);
}

.abax-inspector-card .inspector-card__icon {
  color: var(--dt-muted-fg);
  flex-shrink: 0;
  display: inline-flex;
}

.abax-inspector-card .inspector-card__title {
  color: var(--dt-fg);
}

.abax-inspector-card .inspector-card__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--dt-fg) 8%, transparent);
  color: var(--dt-muted-fg);
  font-size: var(--dt-text-xs);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.abax-inspector-card .inspector-card__summary {
  margin-left: auto;
  color: var(--dt-muted-fg);
  font-size: var(--dt-text-sm);
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.abax-inspector-card .inspector-card__body {
  border-top: 1px solid var(--dt-border);
  background: var(--dt-surface);
}
`;
